export default {"src":"/_next/static/media/tiktok-icon.c7eb0a0b.svg","height":86,"width":75};